export const datasource = 'artifactory';
